module.exports = __webpack_public_path__ + "static/thad-72363a1a80a9e20fd413b57f5e2823dc.png";